import { useTranslation } from "react-i18next";

/**
 * ContactEditClosedScreen — 修正の受付期間 (実施開始日の前日まで) を過ぎたときの案内画面
 * (ADR-0041 Decision 5-1、2026-09-02 改訂)。
 *
 * 無効リンク画面を使い回すと、期限切れなのか壊れたリンクなのか本人に区別がつかないため、
 * 「再送しても直せない」ことが伝わる別文言にする (features/respond の AnswerClosedScreen と同じ作法)。
 */
export function ContactEditClosedScreen() {
  const { t } = useTranslation("contactEdit");
  return (
    <section className="rounded-lg border border-border bg-card p-6 shadow-sm">
      <h1 className="text-base font-semibold">{t("closed.title")}</h1>
      <p className="mt-2 text-sm text-muted-foreground">{t("closed.description")}</p>
    </section>
  );
}
